module.exports = __webpack_public_path__ + "img/penta_icon.17132a48.png";